module.exports = __webpack_public_path__ + "img/notification-info.384531fe.svg";